const FETCH_MISSING_ENROLMENT = "FETCH_MISSING_ENROLMENT";
const FETCH_MISSING_ENROLMENT_SUCCESS = "FETCH_MISSING_ENROLMENT_SUCCESS";
const FETCH_MISSING_ENROLMENT_ERROR = "FETCH_MISSING_ENROLMENT_ERROR";

const IS_ADDING_UPDATE = "IS_ADDING_UPDATE";
const SET_MISSING_ENROLMENT_MANAGER_STATE =
  "SET_MISSING_ENROLMENTY_MANAGER_STATE";

export {
  FETCH_MISSING_ENROLMENT,
  FETCH_MISSING_ENROLMENT_SUCCESS,
  FETCH_MISSING_ENROLMENT_ERROR,
  IS_ADDING_UPDATE,
  SET_MISSING_ENROLMENT_MANAGER_STATE,
};
